var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupayeeImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 350,
    viewBox: "0 0 448 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.618 0.210938H78.8828V45.9885H163.878C195.518 51.1629 219.156 64.0281 228.826 80.9649H78.8828V126.743H225.744C224.104 128.976 222.238 131.04 220.089 132.991C194.133 156.516 140.127 157.591 91.5501 156.771L87.2523 156.686V188.185L247.997 349.749H312.691L163.963 200.201C191.871 197.035 226.819 188.58 250.74 166.95C263.011 155.866 271.494 142.322 275.933 126.714H319.618V80.9367H277.488C274.632 68.1563 268.864 56.4503 260.297 45.9602H319.618V0.210938Z",
    fill: "url(#paint0_linear_427_8815)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3441 351.022L146.46 200.145L221.474 258.392L363.698 75.1689L345.489 61.0312L217.403 226.045L142.388 167.798L0.164062 351.022H29.3441Z",
    fill: "url(#paint1_linear_427_8815)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375.63 97.1987L385.017 28.9141L321.172 54.9273L375.63 97.1987Z",
    fill: "url(#paint2_linear_427_8815)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.249 182.766L205.445 176.715L264.116 101.164L271.892 107.215L213.249 182.766Z",
    fill: "url(#paint3_linear_427_8815)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277.035 116.655L281.05 87.3906L253.68 98.5311L277.035 116.655Z",
    fill: "url(#paint4_linear_427_8815)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0561 212.902L60.2522 206.852L1.60938 282.403L9.41334 288.454L68.0561 212.902Z",
    fill: "url(#paint5_linear_427_8815)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1708 222.343L77.1859 193.078L49.8438 204.219L73.1708 222.343Z",
    fill: "url(#paint6_linear_427_8815)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.148 200.999L318.344 194.92L430.625 50.3203L438.4 56.3712L326.148 200.999Z",
    fill: "url(#paint7_linear_427_8815)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M443.515 65.8117L447.558 36.5469L420.188 47.6873L443.515 65.8117Z",
    fill: "url(#paint8_linear_427_8815)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3648 351.028L145.84 265.41L138.036 259.359L66.8672 351.028H79.3648Z",
    fill: "url(#paint9_linear_427_8815)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M154.972 245.586L127.602 256.726L150.957 274.851L154.972 245.586Z",
    fill: "url(#paint10_linear_427_8815)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_8815",
    x1: 377,
    y1: 439.999,
    x2: 51,
    y2: -105.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_8815",
    x1: -15.9933,
    y1: 231.648,
    x2: 411.981,
    y2: 177.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_427_8815",
    x1: -30.7105,
    y1: 114.835,
    x2: 397.263,
    y2: 60.9191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_427_8815",
    x1: 201.663,
    y1: 146.629,
    x2: 290.613,
    y2: 135.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_427_8815",
    x1: 197.337,
    y1: 112.313,
    x2: 286.288,
    y2: 101.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_427_8815",
    x1: -2.18083,
    y1: 252.309,
    x2: 86.7696,
    y2: 241.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_427_8815",
    x1: -6.50752,
    y1: 217.994,
    x2: 82.444,
    y2: 206.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_427_8815",
    x1: 310.698,
    y1: 134.177,
    x2: 460.984,
    y2: 115.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_427_8815",
    x1: 302.508,
    y1: 69.1943,
    x2: 452.795,
    y2: 50.2614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_427_8815",
    x1: 13.3658,
    y1: 317.198,
    x2: 165.103,
    y2: 298.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_427_8815",
    x1: 8.47903,
    y1: 278.415,
    x2: 160.218,
    y2: 259.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5820A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupayeeImage);
export default __webpack_public_path__ + "static/media/rupayee_image.ebbf9e3797c4c64a30d25e0245ab84b1.svg";
export { ForwardRef as ReactComponent };